import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=3e6cfdb2&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6cfdb2",
  null
  
)

export default component.exports